import AssigneesToolbar from '../../assignees/AssigneesToolbar';
import {ButtonConfig} from '../../../../../../controllers/dialog/ButtonConfig';
import {tAsString} from '../../../../../../common/helpers/react/text/tAsString';
import {ButtonSize, MessageStatus} from '@sabre/spark-react-core/types';
import {cssClasses} from '../../../../../../common/helpers/browser/cssClasses';
import {useControllers} from '../../../../../../common/helpers/react/hooks/useControllers';
import {DefaultTableCheckboxModeProps} from '../../../../common/components/table/DefaultTable';
import LockAgentsModal from './LockAgentsModal';
import {ModalButtons} from '../../../../../../controllers/dialog/ModalButtons';

export type LockAgentsToolbarProps = DefaultTableCheckboxModeProps & {
    onNavigate?: () => void
}

export default function LockAgentsToolbar(props: LockAgentsToolbarProps) {
    const controllers = useControllers();
    const http = controllers.http;
    const dialog = controllers.dialog;

    const showLockModal = (lock: boolean) => {
        if (props.checkedRows.length === 0) {
            dialog.showNotification({
                status: MessageStatus.WARNING,
                content: tAsString('SELECT_SOME_OPTIONS')
            }).andWeAreDone();
            return;
        }

        const confirmLabel = tAsString(lock ? 'LOCK' : 'UNLOCK');

        dialog.showModal({
            title: tAsString(lock ? 'LOCK_AGENTS' : 'UNLOCK_AGENTS'),
            children: <LockAgentsModal
                lock={lock}
                checkedRows={props.checkedRows}
                setCheckedRows={props.setCheckedRows}/>,
            buttons: [
                ModalButtons.CANCEL(dialog),
                {
                    children: confirmLabel,
                    ariaLabel: confirmLabel,
                    className: cssClasses(lock ? 'qa-lock-button' : 'qa-unlock-button'),
                    onClick: async () => {
                        const count = props.checkedRows.length;

                        await dialog.takeNotifiedAction({
                            action: async () => {
                                await controllers.agents.lockAgents$(props.checkedRows, lock);
                            },
                            successMessage: tAsString(lock ? 'X_AGENTS_HAVE_BEEN_LOCKED' : 'X_AGENTS_HAVE_BEEN_UNLOCKED', {count}),
                            errorMessage: tAsString(lock ? 'X_AGENTS_LOCK_FAILED' : 'X_AGENTS_UNLOCK_FAILED', {count}),
                            finalizer: async () => {
                                props.setCheckedRows([]);
                                await dialog.closeModal();
                                await http.navigateTo('agents');
                            }
                        });
                    }
                }
            ]
        }).andWeAreDone();
    };

    const toolbarButtons: ButtonConfig[] = [
        {
            className: cssClasses('aat-autokey-escape', 'qa-lock-toolbar-cancel-button'),
            secondary: true,
            children: tAsString('CANCEL'),
            size: ButtonSize.SMALL,
            onClick: props.onNavigate
        },
        {
            className: cssClasses('qa-unlock-agents-button'),
            children: tAsString('UNLOCK'),
            size: ButtonSize.SMALL,
            onClick: () => showLockModal(false)
        },
        {
            className: cssClasses('qa-lock-agents-button'),
            children: tAsString('LOCK'),
            size: ButtonSize.SMALL,
            onClick: () => showLockModal(true)
        }
    ];

    return <AssigneesToolbar
        buttonsConfig={toolbarButtons}
        checkedRows={props.checkedRows}
        setCheckedRows={props.setCheckedRows}
        labelKey="X_AGENTS_SELECTED"
        onNavigate={props.onNavigate}
    />;
}
